import localeEN from "antd/es/date-picker/locale/en_US";
import localeHR from "antd/es/date-picker/locale/hr_HR";
import moment from "moment";
import "moment/locale/hr";
import LocalizedStrings from "react-localization";
import PartySession from "../session/PartySession";
import { constants } from "../utils/Constants";

const localeUnderscore = "_";
const localeDash = "-";

const localeHRShort = "hr";
const localeENShort = "en";
const localeHRLong = `${localeHRShort}${localeDash}HR`;
const localeENLong = `${localeENShort}${localeDash}US`;

class LocalizationUtil {
  static getLocalizedText(text) {
    const localizedText = this.localize(text);
    return localizedText.text;
  }

  static localize(localizable) {
    const localized = new LocalizedStrings(localizable);

    localized.setLanguage(this.getPartyLocale(true));
    moment.locale(this.getPartyLocale(false));

    return localized;
  }

  static normalizeLocale(locale) {
    if (locale && !locale.includes(localeDash)) {
      if (locale.includes(localeUnderscore)) {
        locale = locale.replace(localeUnderscore, localeDash);
      } else {
        switch (locale) {
          case localeHRShort:
            locale = localeHRLong;
            break;
          case localeENShort:
            locale = localeENLong;
            break;
          default:
            break;
        }
      }
    }

    return locale;
  }

  static getPartyLocale(useUnderscore) {
    let locale =
      PartySession.getLanguage() ||
      navigator.language ||
      navigator.partyLanguage;

    locale = this.normalizeLocale(locale);

    return useUnderscore
      ? locale?.replace(localeDash, localeUnderscore)
      : locale;
  }

  static getPartyLocaleObject() {
    const partyLocale = this.getPartyLocale();

    switch (partyLocale) {
      case constants.LOCALE_HR:
        return localeHR;
      default:
        return localeEN;
    }
  }

  static localDateTime = (date, shouldFormat = true) => {
    return this.localizedDate(
      date,
      shouldFormat,
      constants.MOMENT_DATETIME_FORMAT
    );
  };

  static localDate = (date, shouldFormat = true) => {
    return this.localizedDate(date, shouldFormat, constants.MOMENT_DATE_FORMAT);
  };

  static localizedDate = (date, shouldFormat = true, format) => {
    var dateData = moment(new Date(date));
    if (shouldFormat) {
      const locale = LocalizationUtil.getPartyLocale();
      dateData = dateData.locale(locale).format(format);
    }
    return dateData;
  };

  static isLocalized(localized) {
    const partyLanguage = this.getPartyLocale(true);
    const localizedLanguage = localized.getLanguage();

    return localizedLanguage === partyLanguage;
  }
}

export default LocalizationUtil;
